(function() {
  function initReelsModal() {
    if (!customElements.get('reels-modal')) {
      class ReelsModal extends HTMLElement {
        constructor() {
          super();

          this.reelsModal = this;
          this.reelsModalClose = this.querySelector('.reels-modal__close');
          this.reelsModalMute = this.querySelector('.reels-modal__mute');
          this.reelsModalPlay = this.querySelector('.reels-modal__play');
          this.reelsModalContent = this.querySelector('.reels-modal__content');
          this.videos = document.querySelectorAll('.reels-video');

          this.init();
        }

        init() {
          this.setupModalEvents();
          this.setupVideoEvents();
        }

        setupModalEvents() {
          if (this.reelsModalClose) {
            this.reelsModalClose.addEventListener('click', () => {
              this.closeModal();
            });
          }

          if (this.reelsModalMute) {
            this.reelsModalMute.addEventListener('click', () => {
              const modalVideo = this.querySelector('.reels-modal__content-video video');
              if (modalVideo) {
                modalVideo.muted = !modalVideo.muted;
                this.reelsModalMute.classList.toggle('reels-modal__mute--active');
              }
            });
          }

          if (this.reelsModalPlay) {
            this.reelsModalPlay.addEventListener('click', () => {
              this.toggleVideoPlayPause();
            });
          }

          if (this.reelsModalContent) {
            this.reelsModalContent.addEventListener('click', (e) => {
              if (!e.target.closest('video') && 
                  !e.target.closest('.reels-modal__close') && 
                  !e.target.closest('.reels-modal__mute') && 
                  !e.target.closest('.reels-modal__play')) {
                this.closeModal();
              }
            });
          }
        }

        setupVideoEvents() {
          this.videos.forEach((video) => {
            const duration = parseInt(video.dataset.duration) || 3;
            
            video.addEventListener('loadedmetadata', () => {
              video.currentTime = 0;
            });
            
            video.addEventListener('timeupdate', () => {
              if (video.currentTime >= duration) {
                video.pause();
                video.currentTime = 0;
                video.play();
              }
            });
            
            video.addEventListener('ended', () => {
              video.currentTime = 0;
              video.play();
            });

            video.addEventListener('click', () => {
              this.openModal(video);
            });
          });
        }

        openModal(video) {
          this.querySelector('.reels-modal__content-video').innerHTML = video.outerHTML;
          const modalVideo = this.querySelector('.reels-modal__content-video video');
          
          if (modalVideo) {
            modalVideo.controls = false;
            modalVideo.loop = true;
            modalVideo.muted = this.querySelector('.reels-modal__mute--active') ? true : false;
            
            modalVideo.addEventListener('click', () => {
              this.toggleVideoPlayPause();
            });

            modalVideo.addEventListener('play', () => {
              if (this.reelsModalPlay) {
                this.reelsModalPlay.classList.add('reels-modal__play--active');
              }
            });

            modalVideo.addEventListener('pause', () => {
              if (this.reelsModalPlay) {
                this.reelsModalPlay.classList.remove('reels-modal__play--active');
              }
            });

            modalVideo.play();
          }

          this.classList.add('reels-modal--active');
        }

        closeModal() {
          const modalVideo = this.querySelector('.reels-modal__content-video video');
          if (modalVideo) {
            modalVideo.muted = true;
            modalVideo.pause();
          }
          
          if (this.reelsModalPlay) {
            this.reelsModalPlay.classList.remove('reels-modal__play--active');
          }
          
          this.classList.remove('reels-modal--active');
        }

        toggleVideoPlayPause() {
          const modalVideo = this.querySelector('.reels-modal__content-video video');
          if (modalVideo) {
            if (modalVideo.paused) {
              modalVideo.play();
            } else {
              modalVideo.pause();
            }
          }
        }
      }

      customElements.define('reels-modal', ReelsModal);
    }
  }

  window.addEventListener('load', initReelsModal);
})();